export function SfaRodo() {
  return (
    <div className="space-y-1 text-sm leading-tight">
      <h2 className="text-lg font-bold text-center mb-1">KLAUZULA RODO</h2>

      <div className="space-y-1">
        <div className="space-y-0.5">
          <p className="indent-2">
            1. Zgodnie z art. 13 ust. 1 rozporządzenia Parlamentu Europejskiego
            i Rady (UE) 2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób
            fizycznych w związku z przetwarzaniem danych osobowych i w sprawie
            swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE
            (ogólne rozporządzenie o ochronie danych) - dalej: RODO,
            informujemy, że administratorem Pani/Pana danych osobowych jest ASM
            Sales Force Agency sp z o.o. z siedzibą w Warszawie przy ul. Plac
            Stanisława Małachowskiego 2, będąca Zleceniodawcą usług.
          </p>
        </div>

        <div className="space-y-0.5">
          <p className="indent-2">2. Przetwarzane dane będą dotyczyć:</p>
          <ol className="list-none space-y-0.5 ml-4">
            <li>1) Imię</li>
            <li>2) Nazwisko</li>
            <li>3) e-mail</li>
            <li>4) telefon</li>
            <li>5) PESEL</li>
            <li>6) Adres zamieszkania</li>
            <li>7) Płeć</li>
            <li>8) Data urodzenia</li>
            <li>9) Miejsce urodzenia</li>
            <li>10) Numer rachunku bankowego</li>
            <li>11) Urząd skarbowy</li>
            <li>12) Obywatelstwo</li>
            <li>
              13) Orzeczenie o niepełnosprawności, a jeżeli posiada takie
              orzeczenie, to stopień niepełnosprawności
            </li>
            <li>
              14) Posiadanie statusu ucznia / studenta, a w przypadku posiadania
              takiego statusu:
              <ul className="list-none ml-6 mt-0.5 space-y-0.5">
                <li>a) Nazwa szkoły / uczelni</li>
                <li>b) Numer legitymacji szkolnej / studenckiej</li>
                <li>c) Data ważności legitymacji</li>
              </ul>
            </li>
            <li>
              15) Posiadanie aktywnej umowy o pracę na co najmniej wynagrodzenie
              minimalne, a w przypadku posiadania takiej umowy:
              <ul className="list-none ml-6 mt-0.5 space-y-0.5">
                <li>a) Zakład pracy</li>
                <li>b) Ubezpieczenie chorobowe</li>
              </ul>
            </li>
            <li>
              16) Posiadanie statusu emeryta, a w przypadku posiadania takiego
              statusu:
              <ul className="list-none ml-6 mt-0.5 space-y-0.5">
                <li>a) Nr świadczenia emerytalnego</li>
                <li>b) Data od kiedy świadczenie emerytalne przysługuje</li>
                <li>
                  c) Nazwa jednostki ZUS, w której świadczenie emerytalne
                  zostało wydane
                </li>
              </ul>
            </li>
            <li>
              17) Posiadanie statusu rencisty, a w przypadku posiadania takiego
              statusu:
              <ul className="list-none ml-6 mt-0.5 space-y-0.5">
                <li>a) Nr świadczenia rentowego</li>
                <li>b) Data od kiedy świadczenie rentowe przysługuje</li>
                <li>c) Data do kiedy świadczenie rentowe przysługuje</li>
                <li>
                  d) Nazwa jednostki ZUS, w której świadczenie rentowe zostało
                  wydane
                </li>
                <li>e) Rodzaj renty</li>
              </ul>
            </li>
            <li>
              18) Posiadanie statusu obcokrajowca, a w przypadku posiadania
              takiego statusu:
              <ul className="list-none ml-6 mt-0.5 space-y-0.5">
                <li>a) Numer paszportu</li>
                <li>b) Data ważności paszportu</li>
                <li>c) Posiadanie wizy</li>
                <li>d) Numer wizy</li>
                <li>e) Data ważności wizy</li>
                <li>f) Posiadanie Karty Polaka</li>
                <li>g) Data ważności Karty Polaka</li>
                <li>h) Posiadanie Karty Pobytu</li>
                <li>i) Data ważności Karty Pobytu</li>
              </ul>
            </li>
            <li>19) historia zatrudnienia i doświadczenie zawodowe,</li>
            <li>20) umiejętności i kwalifikacje zawodowe,</li>
            <li>21) wizerunek.</li>
            <li>
              22) dane zawarte w dokumentach potwierdzających powyższe dane lub
              status, w tym w paszporcie, legitymacji szkolnej/studenckiej i
              zaświadczeniu o zatrudnieniu - wyłącznie w niezbędnym zakresie.
            </li>
          </ol>
        </div>

        <p className="indent-2">
          3. Dokumenty co do zasady służą do weryfikacji danych lub statusu. Ich
          kopie, skany lub zdjęcia będą utrwalane i przechowywane tylko wtedy,
          gdy wymaga tego przepis prawa albo gdy w konkretnym przypadku jest to
          niezbędne do udokumentowania danych lub statusu związanego z umową, i
          tylko w zakresie niezbędnym do danego celu.
        </p>

        <div className="space-y-0.5">
          <p className="indent-2">
            4. Dane osobowe pozyskane w związku z zawarciem z Panią/Panem umowy
            będą przetwarzane w następujących celach:
          </p>
          <ol className="list-none space-y-0.5 ml-4">
            <li>
              1) związanych z zawarciem oraz wykonaniem zawartej z Panią/Panem
              umowy, w tym w celu kontaktu przez Zleceniodawcę lub jego
              kontrahentów w celu weryfikacji wykonywania zlecenia,
              rozpatrywania skarg i reklamacji, uzyskiwania wyjaśnień,
              prowadzenia sporów dotyczących roszczeń Zleceniodawcy lub jego
              kontrahentów albo skierowanych przeciwko Zleceniodawcy lub jego
              kontrahentom,
            </li>
            <li>
              2) wypełniania obowiązków prawnych ciążących na Zleceniodawcy w
              związku z prowadzeniem działalności i realizacją zawartej z
              Panią/Panem umowy, w szczególności wynikających z przepisów
              podatkowych, rachunkowych oraz ubezpieczeń społecznych, a także –
              o ile ma zastosowanie – przepisów o przeciwdziałaniu praniu
              pieniędzy;
            </li>
            <li>
              3) ustalenia, dochodzenia lub obrony przed roszczeniami,
              prowadzenia postępowań sądowych i windykacyjnych oraz zapewnienia
              wewnętrznej administracji i bezpieczeństwa,
            </li>
            <li>
              4) udzielania odpowiedzi na Pani/Pana pisma, wnioski i skargi,
            </li>
            <li>
              5) dalszej rekrutacji do zawierania kolejnych umów zlecenia lub
              umów o podobnym charakterze,
            </li>
            <li>
              6) przekazywania Pani/Pana danych osobowych pozyskanych w związku
              z zawarciem z Panią/Panem umowy innym podmiotom poszukującym
              pracowników / współpracowników / zleceniobiorców o Państwa
              kwalifikacjach,
            </li>
            <li>
              7) marketingowych, szkoleniowych i promocyjnych Zleceniodawcy.
            </li>
          </ol>
        </div>

        <div className="space-y-0.5">
          <p className="indent-2">
            5. Podstawą prawną przetwarzania Pani/Pana danych jest:
          </p>
          <ol className="list-none space-y-0.5 ml-4">
            <li>
              1) niezbędność do wykonania umowy lub do podjęcia działań na
              Pani/Pana żądanie przed zawarciem umowy (art. 6 ust. 1 lit. b
              RODO),
            </li>
            <li>
              2) konieczność wypełnienia obowiązku prawnego ciążącego na
              administratorze (art. 6 ust. 1 lit. c RODO),
            </li>
            <li>
              3) w przypadku danych dotyczących niepełnosprawności - niezbędność
              do wypełniania obowiązków i wykonywania szczególnych praw w
              dziedzinie zabezpieczenia społecznego (art. 9 ust. 2 lit. b RODO),
              jeżeli ma zastosowanie,
            </li>
            <li>
              4) niezbędność do celów wynikających z prawnie uzasadnionych
              interesów realizowanych przez administratora (art. 6 ust. 1 lit. f
              RODO),
            </li>
            <li>
              5) zgoda osoby uprawnionej na przetwarzanie jej danych osobowych w
              jednym lub większej liczbie określonych celów (art. 6 ust. 1 lit.
              a RODO).
            </li>
          </ol>
        </div>

        <div className="space-y-0.5">
          <p className="indent-2">
            6. Pozyskane od Pani/Pana dane osobowe mogą być przekazywane:
          </p>
          <ol className="list-none space-y-0.5 ml-4">
            <li>1) podmiotom przetwarzającym je na nasze zlecenie,</li>
            <li>
              2) innym podmiotom gospodarczym poszukującym pracowników /
              współpracowników / zleceniobiorców do wykonywania prac o podobnym
              charakterze jak będące przedmiotem umowy zawartej ze
              Zleceniodawcą,
            </li>
            <li>
              3) organom lub podmiotom publicznym uprawnionym do uzyskania
              danych na podstawie obowiązujących przepisów prawa, np. sądom,
              organom ścigania lub instytucjom państwowym, gdy wystąpią z
              żądaniem, w oparciu o stosowną podstawę prawną,
            </li>
            <li>
              4) kontrahentom Zleceniodawcy (podmiotom na których rzecz
              Zleceniodawca wykonuje usługi) w celach weryfikacji wykonania
              usługi oraz sposobu jej wykonania, prowadzenia ewidencji osób
              wykonujących pracę na terenie jego placówek, przy czym zakres
              Państwa danych jakie mogą być przekazane to: imię, nazwisko, nr
              telefonu, adres e-mail
            </li>
            <li>
              5) podmiotom, u których wykonywane są usługi objęte zleceniem, w
              celu umożliwienia mu prowadzenia ewidencji osób wykonujących pracę
              na terenie jego placówek, przy czym zakres Państwa danych jakie
              mogą być przekazane to: imię, nazwisko, nr telefonu, adres e-mail.
            </li>
          </ol>
        </div>

        <p className="indent-2">
          7. Pani/Pana dane nie będą przekazane do państw trzecich.
        </p>

        <div className="space-y-0.5">
          <p className="indent-2">
            8. Okres przetwarzania Pani/Pana danych osobowych jest uzależniony
            od celu w jakim dane są przetwarzane. Okres, przez który Pani/Pana
            dane osobowe będą przechowywane jest obliczany w oparciu o
            następujące kryteria:
          </p>
          <ol className="list-none space-y-0.5 ml-4">
            <li>1) czasu obowiązywania umowy,</li>
            <li>
              2) przepisy prawa, które mogą nas obligować do przetwarzania
              danych przez określony czas,
            </li>
            <li>3) okres, który jest niezbędny do obrony naszych interesów,</li>
            <li>
              4) w przypadku danych objętych dobrowolną zgodą - bezterminowo do
              chwili cofnięcia zgody.
            </li>
          </ol>
        </div>

        <div className="space-y-0.5">
          <p className="indent-2">
            9. Ponadto, informujemy, że ma Pani/Pan prawo do:
          </p>
          <ol className="list-none space-y-0.5 ml-4">
            <li>1) dostępu do swoich danych osobowych,</li>
            <li>
              2) żądania sprostowania swoich danych osobowych, które są
              nieprawidłowe oraz uzupełnienia niekompletnych danych osobowych,
            </li>
            <li>
              3) żądania usunięcia swoich danych osobowych, w szczególności w
              przypadku cofnięcia przez Panią/Pana zgody na przetwarzanie, gdy
              nie ma innej podstawy prawnej przetwarzania,
            </li>
            <li>
              4) żądania ograniczenia przetwarzania swoich danych osobowych,
            </li>
            <li>
              5) wniesienia sprzeciwu wobec przetwarzania swoich danych, ze
              względu na Pani/Pana szczególną sytuację, w przypadkach, kiedy
              przetwarzamy Pani/Pana dane na podstawie naszego prawnie
              usprawiedliwionego interesu czy też na potrzeby marketingu
              bezpośredniego,
            </li>
            <li>6) przenoszenia swoich danych osobowych,</li>
            <li>
              7) wniesienia skargi do organu nadzorczego zajmującego się ochroną
              danych osobowych, tj. Prezesa Urzędu Ochrony Danych Osobowych.
            </li>
          </ol>
        </div>

        <p className="indent-2">
          10. W zakresie, w jakim Pani/Pana dane są przetwarzane na podstawie
          zgody - ma Pani/Pan prawo wycofania zgody na przetwarzanie danych w
          dowolnym momencie. Wycofanie zgody nie ma wpływu na zgodność z prawem
          przetwarzania, którego dokonano na podstawie Pani/Pana zgody przed jej
          wycofaniem. Zgodę może Pani/Pan wycofać poprzez wysłanie oświadczenia
          o wycofaniu zgody na nasz adres korespondencyjny bądź adres e-mailowy.
        </p>

        <p className="indent-2">
          11. Podanie danych zawartych w kwestionariuszu jest dobrowolne, jednak
          ich niepodanie spowoduje brak możliwości zawarcia z Państwem umowy, a
          cofnięcie zgody może spowodować niemożliwość realizacji zawartej już
          umowy.
        </p>

        <p className="indent-2">
          12. Informujemy, że nie korzystamy z systemów służących do
          zautomatyzowanego podejmowania decyzji.
        </p>

        <p className="indent-2">
          13. Nie przewiduje się przekazywania Pani/Pana danych osobowych poza
          obszar Europejskiego Obszaru Gospodarczego.
        </p>

        <div className="space-y-1 mt-2 p-4">
          <h3 className="text-base font-bold text-center">
            Potwierdzenie zapoznania się z klauzulą RODO
          </h3>
          <p className="indent-2">
            Potwierdzam, że zapoznałam(-em) się z powyższą klauzulą RODO. Jeżeli
            przetwarzanie określonych danych lub realizacja określonego celu
            wymaga zgody, zgoda jest odbierana odrębnie.
          </p>
          <p className="indent-2 mt-2">
            Oświadczenie zaakceptowane elektronicznie
          </p>
        </div>
      </div>
    </div>
  );
}
